import { forwardRef, type Ref, type SVGProps } from "react";
const IconElectricityOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25 9h-2V5a3 3 0 0 0-6 0v4h-2V5a3 3 0 0 0-6 0v4H7a2.006 2.006 0 0 0-2 2v2a2.006 2.006 0 0 0 2 2v2a9.01 9.01 0 0 0 5 8.05V26a2.006 2.006 0 0 0 2 2h1v2h2v-2h1a2.007 2.007 0 0 0 2-2v-.95A9.01 9.01 0 0 0 25 17v-2a2.006 2.006 0 0 0 2-2v-2a2.006 2.006 0 0 0-2-2m-6-4a1 1 0 1 1 2 0v4h-2zm-7-1a1 1 0 0 0-1 1v4h2V5a1 1 0 0 0-1-1m11 13a6.99 6.99 0 0 1-4 6.32q-.489.225-1 .389v2.29h-4V23.71a8 8 0 0 1-1-.389 6.99 6.99 0 0 1-4-6.32V15h14zM7 13h18v-2H7z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconElectricityOutlineSVG);
ForwardRef.displayName = "IconElectricityOutline";
export { ForwardRef as IconElectricityOutline };
